import axios from '../utils/axios';

export async function getTeams(queryString: string = ''): Promise<any> {
  return axios.get(`/teams?${queryString}`).then((res) => res.data);
}

export async function createTeam(team: any): Promise<any> {
  return axios.post('/teams', team).then((res) => res.data);
}
